import CoolerDoor from './CoolerDoor'
import CoolerStyle from './CoolerStyle'
import EquipmentType from './EquipmentType'
import ModelGroup from './ModelGroup'
import SpecificModelReason from './SpecificModelReason'
import Model from './Model'
import EquipmentGraphics from './EquipmentGraphics'
import BaseLineItemEntity from '../baseclasses/BaseLineItemEntity'
import * as _ from "lodash";

export class CoolerLineItem extends BaseLineItemEntity {
    ID?: number;
    EquipmentTypeID?: number;
    EquipmentType?: EquipmentType;
    ModelGroupID?: number;
    ModelGroup?: ModelGroup;
    SpecificModelReasonID?: number;
    SpecificModelReason?: SpecificModelReason;
    ModelID?: number;
    Model?: Model;
    EquipmentGraphicsID?: number;
    EquipmentGraphics?: EquipmentGraphics;
    SpecificModelNeeded: boolean;
    EquipmentLocation: string;
    NumberOfCoolers: number;
    DefaultModel: string;
    MaterialNumber: string;
    CONAModelGroup: string;
    IncludeTopper?: boolean;
    CoolerDoorID?: number;
    CoolerDoor?: CoolerDoor;
    CoolerStyleID?: number;
    CoolerStyle?: CoolerStyle;

    constructor() {
        super();
        this.EquipmentType = new EquipmentType();
        this.ModelGroup = new ModelGroup();
        this.SpecificModelReason = new SpecificModelReason();
        this.Model = new Model();
        this.EquipmentGraphics = new EquipmentGraphics();
        this.CoolerDoor = new CoolerDoor();
        this.CoolerStyle = new CoolerStyle();
    }

    CloneShallow(): CoolerLineItem {
        var newItem: CoolerLineItem = _.clone(this);
        newItem.ModelGroup = null;
        newItem.Model = null;
        newItem.EquipmentGraphics = null;
        newItem.EquipmentType = null;
        newItem.SpecificModelReason = null;
        newItem.CoolerDoor = null;
        newItem.CoolerStyle = null;
        return newItem;
    }
}

export default CoolerLineItem;